import './FormField.css';
import React, { useState, useRef } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
const FormField = _ref => {
  let {
    name,
    placeholder,
    value,
    changeEvent,
    blurEvent,
    type,
    label,
    id,
    labelLight,
    fieldError,
    autoComplete = 'off',
    required = false,
    focusEvent
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [highLightText, setHighLightText] = useState(false);
  const clickedTextRef = useRef(false);
  function handleChange(event) {
    changeEvent(event);
  }
  function handleBlur(event) {
    if (blurEvent) blurEvent(event.target.value);
    clickedTextRef.current = false;
    setHighLightText(false);
  }
  function handleTextMousedown() {
    clickedTextRef.current = true;
  }
  function handleFocus(event) {
    if (focusEvent) focusEvent(event.target.value);
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: "form-group lr__form-group"
  }, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, name), /*#__PURE__*/React.createElement("label", {
    className: `body-small form-label ${labelLight ? 'lr__label-light' : ''}`,
    htmlFor: id
  }, label, required ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "*") : ''), /*#__PURE__*/React.createElement("input", {
    className: `
            form-input lr__field input-text-primary
            ${highLightText ? 'input-text-primary--focused' : ''}
          `,
    name: name,
    placeholder: placeholder,
    type: type,
    value: value,
    id: id,
    onChange: handleChange,
    autoComplete: autoComplete,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMouseDown: handleTextMousedown,
    title: label,
    "aria-label": label
  }), fieldError && fieldError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, fieldError) : null));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "c11x4s7o";
const ltrStyles = "l11w6pd8";
const rtlStyles = "r1qwxqiq";
export default FormField;